export const setRobotsMetaTag = (robots_tag) => {
  if (robots_tag == null) {
    return
  }

  const robotMetaTag = document.head.querySelector("[name=robots]")
  robotMetaTag.content = robots_tag
}

export const setLinkHeadTag = (rel, url) => {
  let new_tag = document.createElement("a")
  new_tag.href = url
  new_tag.rel = rel

  let target = document.head.querySelector(`[rel=${rel}]`)
  target ? target.replaceWith(new_tag) : document.head.appendChild(new_tag)
}

export const setItemListJsonLd = (listings) => {
  const schema = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    name: document.title,
    url: window.location.href,
    itemListElement: listings.map((listing, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: listing.title,
      url: listing.url,
    })),
  }

  let el = document.querySelector('script[data-schema-type="item-list"]')
  if (!el) {
    el = document.createElement("script")
    el.type = "application/ld+json"
    el.dataset.schemaType = "item-list"
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(schema)
}
